import React from "react";
import { Link } from "react-router-dom";
import { profile } from "../../data/site";
import { ArrowUp, SOCIAL_ICONS } from "../../lib/icons";

const YEAR = new Date().getFullYear();

const Footer = () => (
  <footer className="footer">
    <div className="shell footer__inner">
      <Link to="/" className="brand footer__brand">
        <span className="brand__mark" aria-hidden="true">OA</span>
        <span className="brand__text">
          Ouri Alkada
          <small>{profile.location}</small>
        </span>
      </Link>

      <ul className="footer__links">
        {profile.socials.map((social) => {
          const Icon = SOCIAL_ICONS[social.icon];
          return (
            <li key={social.label}>
              <a
                className="icon-btn"
                href={social.url}
                target={social.url.startsWith("http") ? "_blank" : undefined}
                rel="noopener noreferrer"
                aria-label={social.label}
              >
                <Icon size={17} />
              </a>
            </li>
          );
        })}
        <li>
          <button
            type="button"
            className="icon-btn"
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            aria-label="Back to top"
          >
            <ArrowUp size={17} />
          </button>
        </li>
      </ul>

      <div className="footer__meta">
        <span className="footer__copy">© {YEAR} Ouri Alkada — built from scratch in React.</span>
        <span>
          <b>●</b> All systems operational · Press <kbd>K</kbd> to jump anywhere
        </span>
      </div>
    </div>
  </footer>
);

export default Footer;
